/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Section_NameInputs */



/**
* | output |
* | --- |
* | "Name" |
*
* @param {Team_Share_Section_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_section_name = /** @type {((inputs?: Team_Share_Section_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Section_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Name")
	if (locale === "de") return /** @type {LocalizedString} */ ("Name")
	if (locale === "it") return /** @type {LocalizedString} */ ("Name")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Name")
	if (locale === "es") return /** @type {LocalizedString} */ ("Name")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Name")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Name")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Name")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Name")
	return /** @type {LocalizedString} */ ("Name")
});